import React from 'react';

import ChatIconFilled from 'components/lib/icons/chat_icon_filled';

export default function ChatMetadataIcon() {
  return (
    <div className="itemMetadata-chatIcon">
      <ChatIconFilled />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/chat/chat_metadata_icon.jsx